import React from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingModal, DeliveryFlowModal, DeliveryFlowDialog } from '../common';
import useDeliveryMethod from './hook/useDeliveryMethod';
import useDeliveryControlFlow from '../common/hook/useDeliveryControlFlow';
import displayFlow from './displayFlow';
import displayFlowMY from './displayFlow-MY';
import useDeliveryData from '../common/hook/useDeliveryData';
import useStoreLocation from '../common/hook/useStoreLocation';
import useAuthentication from '../common/hook/useAuthentication';
import useCustomerAddressList from '../common/hook/useCustomerAddressList';
import useCustomerAddressMethod, {
  useDeleteCustomerAddressMethod,
  useEditCustomerAddressMethod
} from './hook/useCutomerAddressMethod';
import useDeliverySlot from '../common/hook/useDeliverySlot';
import { persistor } from '../../store';
import { getStoreOpenTime } from '../../utils/utils';
import { trackScreen } from '../../utils/eventTracking';
import { useSite } from '../../context/siteContext';
import {
  getPreAddItem,
  getPreSetupDelivery,
  getPreStartFlow,
  removedPreSetupDelivery,
  removePreAddItem,
  removePreStartFlow
} from '../../utils/LocalStorage/deliveryMothod';
import {
  DELIVERY_TYPE_MENU,
  STORE_CLOSE_WARNING
} from '../../constant/deliveryFlow';
import { useBootStrap } from '../Bootstrap/hook';
import { useCarts } from '../common/hook/useCart';

const useStyle = makeStyles((theme) => ({
  modalRoot: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: -24,
      bottom: 0,
      height: 'unset !important',
      transform: 'unset !important',
      left: 'unset !important',
      top: 'unset !important',
    },
  },
  modalContent: {
    transition: 'width 1s, height 1s',
  }
}));

export default function DeliveryMethod() {
  const classes = useStyle();
  const { MySite } = useSite();
  const bootAction = useBootStrap();
  const authentication = useAuthentication();
  const customerAddress = useCustomerAddressList();
  const deliveryHook = useDeliveryMethod();
  const deliveryControl = useDeliveryControlFlow();
  const deliveryForm = useDeliveryData();
  const storeLocation = useStoreLocation();
  const customerAdd = useCustomerAddressMethod();
  const customerEdit = useEditCustomerAddressMethod();
  const customerDeleted = useDeleteCustomerAddressMethod();
  const deliverySlot = useDeliverySlot();
  const warningStoreOpenTime = getStoreOpenTime();
  const cartControl = useCarts();
  const deliveryData = useDeliveryData();
  const reorderLoading = _.get(cartControl, 'reorder.loading', false);

  const [currentPage, setCurrentPage] = React.useState({});
  const modalRef = React.useRef(null);

  const handlerChangePage = (page, pendingPage = '') => {
    const nextPage = currentPage.nextPage(deliveryControl.stateFlow, page, {
      authentication,
      formData: deliveryForm.formData,
      saveRecentAddress: deliveryHook.saveRecentAddress,
      modalControl: deliveryControl,
      formControl: deliveryForm,
      storeTime: warningStoreOpenTime,
    });

    if (nextPage !== currentPage.name) {
      deliveryControl.deliveryPageChange({
        page: nextPage,
        pendingPage,
        fromPage: currentPage.name
      });
    }
  };

  const handlerBackPage = () => {
    if (_.isFunction(currentPage.backPage)) {
      currentPage?.onClose(deliveryControl.stateFlow, {
        authentication,
        formControl: deliveryForm,
        modalControl: deliveryControl,
      });
    }
    deliveryControl.popPage();
  };

  const handlerCloseModal = () => {
    if (_.isFunction(currentPage.onClose)) {
      currentPage?.onClose(deliveryControl.stateFlow, {
        authentication,
        modalControl: deliveryControl,
        formControl: deliveryForm,
      });
    }
    const delivery = _.get(deliveryData, 'activeDelivery', {});
    const shippingAddress = _.get(deliveryData, 'shippingAddress', {});
    deliveryControl.clearStoreWithoutArea({ ...delivery, shippingAddress });
    deliveryControl.setFromDifferentStoreType(false);
    deliveryControl.setHideOnDemand(false);
    deliveryControl.setFromWidget(false);
    deliveryControl.setRedirectTo('');
    deliveryControl.closeModal();
    deliveryControl.setDisableGoFresh(false);
    deliveryControl.setDisableHyper(false);
    deliveryControl.defaultB2BActive();
    deliveryForm.updateForm('filter', { storeType: null });
  };

  React.useEffect(() => {
    let nextPage;
    if (MySite) {
      nextPage = displayFlowMY[deliveryControl.currentPage];
    } else {
      nextPage = displayFlow[deliveryControl.currentPage];
    }

    if (nextPage) {
      trackScreen('place_selected');
      setCurrentPage(nextPage);
    } else {
      deliveryControl.closeModal(true);
    }
  }, [deliveryControl.currentPage]);

  React.useEffect(() => {
    if (deliveryControl.reloadRequest) {
      persistor.flush();
      window.location.reload();
    }
  }, [deliveryControl.reloadRequest]);

  React.useEffect(() => {
    if (bootAction.appReady) {
      const loadDeliveryPopup = getPreSetupDelivery();
      if (loadDeliveryPopup && authentication.isLoggedIn) {
        const preStartFLow = getPreStartFlow();
        const preAddItem = getPreAddItem();
        const isCanAddItem = deliveryForm.isCompleteForm || deliveryForm.formHadData;

        if (preStartFLow) {
          if (preStartFLow === 'OD') {
            if (warningStoreOpenTime.isClose) {
              deliveryControl.setPreStack([STORE_CLOSE_WARNING], true);
            } else {
              deliveryControl.startOnDemand();
            }
          } else if (preStartFLow === 'HD') {
            deliveryControl.startHomeDelivery();
          } else if (preStartFLow === 'CC') {
            deliveryControl.startClickAndCollect();
          }
          removePreStartFlow();
        } else {
          if (isCanAddItem) {
            cartControl.addItemToCarts(cartControl.cartId, preAddItem);
          } else {
            deliveryControl.startDeliveryFlow(DELIVERY_TYPE_MENU, false, true);
            if (preAddItem) {
              deliveryControl.setPreAddItem(preAddItem);
            }
          }
        }
        removedPreSetupDelivery();
        removePreAddItem();
      }
    }
  }, [bootAction.appReady]);

  return (
    <>
      <DeliveryFlowDialog
        className={classes.modalRoot}
        isOpen={deliveryControl.showModal}
        onClose={() => false}
        BackdropProps={{
          timeout: 0
        }}
        modalRef={modalRef}
      >
        <div className={classes.modalContent}>
          {currentPage && currentPage.Component ? (
            <currentPage.Component
              onClose={handlerCloseModal}
              onNext={handlerChangePage}
              onBack={handlerBackPage}
              modalRef={modalRef}
            />
          ) : ''}
        </div>
      </DeliveryFlowDialog>
      <LoadingModal
        open={
          deliveryControl.isProcess
          || storeLocation.storeLoading
          || customerAddress.isProcess
          || customerAdd.addIsLoading
          || customerEdit.editIsLoading
          || customerDeleted.isLoading
          || deliverySlot.isLoading
          || reorderLoading
        }
      />
    </>
  );
}
